import { Box, Button, Divider, } from '@mui/material';
import { Content } from './Content'
import { Style } from './Style'
import { Details } from './Details'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { rqx } from '../../../../../../../../../../core/request/API';
import { env } from '../../../../../../../../../../core/Env';

export const Tabs = ({ product_state }) => {
    const { prodTemplate, subCategory, selectedPickupAddress } = product_state
    const inputs = prodTemplate.data.inputs
    const history = useHistory()
    const q = new URLSearchParams(window.location.search);

    const handlerBtnTabs = (step) => {
        if (q.get('id') !== null) {
            history.push(`/campaign/promo/product/attract/templates/customization?step=${step}&id=${q.get('id')}`)
        } else {
            history.push(`/campaign/promo/product/attract/templates/customization?step=${step}`)
        }
    }

    const validateBtn = (name) => {
        let form_default = inputs.title.value === '' || inputs.reg_price.value === '' || inputs.category.value === '' || inputs.sub_category.value === '' || inputs.weight.value === '' || inputs.length.value === '' || inputs.width.value === '' || inputs.height.value === '' 
        if (name === 'styles') {
            if (inputs.pickup.value) {
                if (form_default || selectedPickupAddress.data == null) {
                    return true
                }
            } else if (inputs.delivery.value) {
                if (form_default || inputs.delivery_option.value === '' || inputs.pickup_option.value === '') {
                    return true
                }
            } else {
                if (form_default || inputs.delivery.value === false || inputs.pickup.value === false) {
                    return true
                }
            }
        } else {
            if (q.get('id') !== null) {
                if (inputs.facebook.value === '' || inputs.instagram.value === '') {
                    return true
                }
            } else {
                if (inputs.bg.type === 'default' || inputs.logo.type === 'default' || inputs.ft_img.type === 'default' || inputs.facebook.value === '' || inputs.instagram.value === '') {
                    return true
                }
            }
        }
    }

    const handlerChange = async (e, i, manualOverrides) => {
        const { name, value, checked } = e.target
        const inputs = { ...prodTemplate.data.inputs }

        if (manualOverrides) {
            // Apply manual override and prevent further validation
            inputs[name] = {
                ...inputs[name],
                value: inputs[name]?.value ?? '',
                stat: manualOverrides.stat ?? false,
                msg: manualOverrides.msg ?? '',
            };

            prodTemplate.set({ ...prodTemplate.data, inputs });
            return;
        }

        if (inputs[name]?.value !== value) {
            if (name === 'promo_details') {
                inputs[name][i].value = value
                inputs[name][i].stat = value === '' ? true : false
                inputs[name][i].msg = value === '' ? 'This field is required.' : ''
            } else if (name === 'discount_percent' && parseFloat(value) > 99.9991) {
                inputs[name].value = 100
                inputs[name].stat = true
                inputs[name].msg = 'Should not be more than 100%'
            } else if (name === 'category') {
                inputs[name].value = value
                inputs[name].stat = value === '' ? true : false
                inputs[name].msg = value === '' ? 'This field is required.' : ''
                const sub_cat = await rqx.get(`<<tool>>/${env()}/template/subcategory`, { category_id: value })
                subCategory.set(sub_cat)
            } else if (name === 'delivery' || name === 'pickup') {
                inputs[name].value = checked;

                // Get the actual current state after update
                const pickupChecked = name === 'pickup' ? checked : inputs.pickup.value;
                const deliveryChecked = name === 'delivery' ? checked : inputs.delivery.value;
                const atLeastOneSelected = pickupChecked || deliveryChecked;

                // Update error state for BOTH checkboxes
                inputs.pickup.stat = !atLeastOneSelected;
                inputs.delivery.stat = !atLeastOneSelected;

                // Clear or set error messages
                if (atLeastOneSelected) {
                    inputs.pickup.msg = '';
                    inputs.delivery.msg = '';
                } else {
                    inputs.pickup.msg = 'Required to choose at least one';
                    inputs.delivery.msg = 'Required to choose at least one';
                }

                // Clear delivery_option when delivery is unchecked
                if (name === 'delivery' && checked === false) {
                    inputs.delivery_option.value = '';
                }
            } else if (name === 'end') {
                inputs[name].value = value
                inputs[name].stat = value === '' ? true : value < inputs.start.value ? true : false
                inputs[name].msg = value === '' ? 'This field is required.' : value < inputs.start.value ? 'Invalid Date' : ''
            } else if (name === 'partial') {
                const rate = Number((parseFloat(inputs.reg_price.value.replace(/,(?=\d{3})/g, '')) - (parseFloat(inputs.reg_price.value.replace(/,(?=\d{3})/g, '')) * (parseFloat(inputs.discount_percent.value) / 100))).toFixed(2));
                const numericValue = Number(value)
                if (value === '') {
                    inputs[name].value = value
                    inputs[name].stat = true
                    inputs[name].msg = 'This field is required.'
                } else if (!/^(?!0\d)\d*(\.\d+)?$/.test(numericValue) || isNaN(numericValue)) {
                    inputs[name].value = value
                    inputs[name].stat = true
                    inputs[name].msg = 'Value must be a positive number without leading zeros.'
                } else if (numericValue >= rate) {
                    inputs[name].value = value;
                    inputs[name].stat = true;
                    inputs[name].msg = `Value must be lesser than the rate (₱${rate}).`;
                } else {
                    inputs[name].value = value
                    inputs[name].stat = false
                    inputs[name].msg = ''
                }
            } else {
                inputs[name].value = value
                inputs[name].stat = value === '' ? true : false
                inputs[name].msg = value === '' ? 'This field is required.' : ''
            }
            prodTemplate.set({ ...prodTemplate.data, inputs })
        }
    }
    
    return (
        <Box height="100%" width="100%" display="flex" flexDirection="column">
            <Box display="flex" alignItems="center" justifyContent="space-between" p={2}>
                <Box component={Button} width={80} onClick={() => handlerBtnTabs(1)}
                    border="1px solid"
                    bgcolor={q.get('step') === '1' ? "#009F4D" : "#fff"} color={q.get('step') === '1' ? "#fff" : "#000"}
                    sx={{ ':hover': { bgcolor: q.get('step') === '1' ? "#009F4D" : "#fff" } }}
                >
                    Content
                </Box>
                <Box component={Button} width={80} onClick={() => handlerBtnTabs(2)} disabled={validateBtn('styles')}
                    border="1px solid"
                    bgcolor={q.get('step') === '2' ? "#009F4D" : "#fff"} color={q.get('step') === '2' ? "#fff" : "#000"}
                    sx={{ ':hover': { bgcolor: q.get('step') === '2' ? "#009F4D" : "#fff" } }}
                >
                    Style
                </Box>
                <Box component={Button} width={80} onClick={() => handlerBtnTabs(3)} disabled={validateBtn('details')}
                    border="1px solid"
                    bgcolor={q.get('step') === '3' ? "#009F4D" : "#fff"} color={q.get('step') === '3' ? "#fff" : "#000"}
                    sx={{ ':hover': { bgcolor: q.get('step') === '3' ? "#009F4D" : "#fff" } }}
                >
                    Details
                </Box>
            </Box>
            <Divider />
            <Box height="100%" width="100%" className="overflowY">
                {
                    q.get('step') === '1' ?
                        <Content inputs={inputs} handlerChange={handlerChange} product_state={product_state} />
                        :
                        q.get('step') === '2' ?
                            <Style inputs={inputs} handlerChange={handlerChange} prodTemplate={prodTemplate} />
                            :
                            <Details inputs={inputs} handlerChange={handlerChange} prodTemplate={prodTemplate} />
                }
            </Box>
        </Box>
    )
}
